import React from 'react'
import NavBar from '../Components/Main/NavBar';
import Footer from '../Components/Main/Footer';
import '../css/Products/ProductType.css'
import { useNavigate } from 'react-router-dom';
import Materials from '../Assets/materials.png';
import Machine from '../Assets/machines.png'

const ProductType = () => {
    const navigate=useNavigate();
  return (
    <div>
        <NavBar />
        <div className='product-tpye-container'>
            <div className='product-type-row'>
                <div className='product-type-card' onClick={() => navigate('/termekek/Stern%20Weber%20Fog%C3%A1szati%20Kezel%C5%91egys%C3%A9gek?type=machine')}>
                    <h1>Fogászati Gépek</h1>
                    <img src={Machine} alt="Fogászati Gépek" />
                </div>
                <div className='product-type-card' onClick={() => navigate('/termekek/Egyszerhaszn%C3%A1latos%20term%C3%A9kek?type=material')}>
                    <h1>Fogászati Anyagok</h1>
                    <img src={Materials} alt="Fogászati Anyagok" />
                </div>
            </div>
        </div>
        <Footer />
    </div>
  )
}

export default ProductType